import { cn } from "@/lib/utils";
import { Typography } from "../ui/typography";

const TitleComponent = ({
  title,
  subtitle,
  className,
  badgeClassName,
}: {
  title: string;
  subtitle?: string;
  className?: string;
  badgeClassName?: string;
}) => {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div
        className={cn(
          "w-[4px] md:w-[7px] bg-primary-500 rounded-md h-[21px] md:h-[28px]",
          badgeClassName
        )}
      ></div>
      <div className="text-start py-1 space-y-2.5">
        <Typography variant="bodySMedium" className="md:text-base">
          {title}
        </Typography>
        {subtitle && <Typography variant="bodySRegular">{subtitle}</Typography>}
      </div>
    </div>
  );
};

export default TitleComponent;
